import * as React from "react";
import Layout from "../components/layout";
import Networks from "../components/OurNetworks/Networks";
import Seo from "../components/seo";

const OurNetworks = () => (
  <Layout>
    <Seo title="Affiliate Companies" />
    <Networks />
  </Layout>
);

export default OurNetworks;
